export enum ViewContext {
  Teams,
  TeamRosters,
  People,
  TeamSurvey,
  Forms,
  TeamBench,
  OpportunityBoard,
  CredentialingDetailsReport,
  AllCredentialingDetailsReport,
  PersonScenarioReport,
  AllPaymentRecordsReport,
  CredentialPaymentRecordsReport,
  AllInvoiceReport,
  PersonCredentialApplicationReport,
  AllInProgressPersonCredentialApplications,
  InProgressPersonCredentialApplications,
}
